import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip, Modal } from '@material-ui/core';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const PurchaseCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [errorMessageModel, setErrorMessageModel] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, userId, token, logout]);


    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;
    const [orderQuantities, setOrderQuantities] = useState({});

    useEffect(() => {
        fetchData('PurchaseApi', `/purchaseOrder/${companyId}/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Purchase);
                    setSelectedItems(response.response_data.PurchaseDetails);

                    setFormData(prevData => ({
                        ...prevData,
                        CreatedBy: userId,
                        BranchId: branchId,
                        CompanyId: companyId,
                    }));
                    handleCalculation()

                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;
        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let amt = (quantity * rate).toFixed(2);
        let amount = (quantity * grate).toFixed(2);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3) {
            igstAmount = ((amount * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((amount * cgstRate) / 100).toFixed(2);
            sgstAmount = ((amount * sgstRate) / 100).toFixed(2);
        }
        let mfgdate = formatDateForInput(item.ManufacturingDate);
        let expdays = parseAndFix(item.ExpiryDays);
        let expdate = new Date(mfgdate);
        expdate.setDate(expdate.getDate() + expdays);
        expdate = expdate.toISOString().split('T')[0];

        const totalAmount = parseAndFix(amount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
            TaxableAmount: amount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),
            ExpirydDate: expdate,
        };
    };


    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, PaidAmount) => {

        const freightGSTRate = parseAndFix(formData.FreightGSTRate);
        const packingGSTRate = parseAndFix(formData.PackingGSTRate);
        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (PaidAmount));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            Amount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            TotalAmount: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
        }));
    };

    // Calculation
    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setSelectedItems((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.FreightAmount);
            const PaidAmount = parseAndFix(formData.PaidAmount);

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                PaidAmount,
            );

            return updatedItemData;
        });
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'PaidAmount'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        const fixedValue = parseAndFix(value).toFixed(2);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
        setSelectedItems(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations       
        const PaidAmount = dynamicValue('PaidAmount');
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');

        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            PaidAmount,
        );
    };

    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const CreateData = {
            Purchase: formData,
            PurchaseDetails: selectedItems
        };

        // Validate form data here if needed

        postData('PurchaseApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/PurchaseIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);

            const updatedItemData = updatedItemList.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.FreightAmount);
            const PaidAmount = parseAndFix(formData.PaidAmount);

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                PaidAmount,
            );


            closeConfirmDialog();
        }
    };

    // For Item 

    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }


        try {
            // Fetch data from the API
            const response = await fetchData('PurchaseOrderApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleItemChange = (newValue) => newValue;


    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = '';  //parseFloat(selectedItemDetail.PurchaseRate.toFixed(2)) || 0;
            const cgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const sgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = parseFloat((cgstamt + sgstamt + igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            const mfgdate = new Date();
            const expdays = parseAndFix(selectedItemDetail.ExpiryDays);
            let expdate = new Date(mfgdate);
            expdate.setDate(expdate.getDate() + expdays);
            //expdate = expdate.toISOString().split('T')[0];


            setModalData({
                ...modalData,
                Rate: rate, //selectedItemDetail.PurchaseRate.toFixed(2), // Assuming Rate is a number
                GSTRate: gstrate,
                ItemName: selectedOption ? selectedItemDetail.Code + '-' + selectedItemDetail.Name : '',
                ItemId: selectedOption ? selectedOption.value : '',
                HSNCode: selectedOption ? selectedItemDetail.HSNCode : '',
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                RequestedQuantity: quantity,
                OrderQuantity: '0',
                ExpiryDays: expdays,
                ExpirydDate: expdate,
                ManufacturingDate: mfgdate,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '',
                GSTRate: '0.00',
                // ItemName: selectedOption ? selectedOption.label : '',
                ItemName: selectedOption ? selectedItemDetail.Name : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                RequestedQuantity: '',
                OrderQuantity: '0',
                ExpiryDays: '0',
                ExpirydDate: '0',
                ManufacturingDate: '0',
            });
        }
    };
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const [itemdetails, setItemDetails] = useState([]);

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('PurchaseOrderApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                setItemDetails(response.response_data);
            }

            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            setFormData(prevData => ({
                ...prevData,
                BillDate: formattedDate,
                PurchaseBillDate: formattedDate,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName1: '',
            ItemId: '',
            Quantity: '',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }



        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...selectedItems, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setSelectedItems(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName1: '',
                ItemId: '',
                Quantity: '',
                Rate: '',
                Amount: '',
                GSTRate: '',
                GSTAmount: '',
                TotalAmount: '',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();

            ///Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);   
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);            
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.FreightAmount);
            const PaidAmount = parseAndFix(formData.PaidAmount);
           
            totalCalculation(
                Quantity,
                Amount,
                DiscountAmount,
                TaxableAmount,
                CGSTAmount,
                SGSTAmount,
                IGSTAmount,
                TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                PaidAmount,
            );

        } else {

            console.log("Validation errors:", errors);
            // setErrorMessageModel(errors);
        }

    };

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        if (name === 'Quantity') {

            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(modalData.Rate) || '';
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            });
        }
        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(value) || 0;
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate,//rate.toFixed(2), // Assuming Rate is a number                   
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,

            });

        }

    };


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Purchase Create
                </h6>
                <Modal open={confirmDialogOpen} onClose={closeConfirmDialog} style={{ marginTop: '10%' }}>
                    <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '30%', textAlign: 'center' }}>
                        <h5>Confirm Delete</h5>
                        <p>Are you sure you want to delete this item? 🤕</p>
                        <Button style={{ margin: '8px', color: 'red' }} onClick={handleDelete}>Delete</Button>
                        <Button style={{ margin: '8px', color: 'grey' }} onClick={closeConfirmDialog}>Cancel</Button>
                    </div>
                </Modal>

                <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                    <div className="mr-4">
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '200px' : '170px',
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>
                    <div className="mr-4">
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billDate" style={{ fontSize: '12px' }}>
                            PO Date :
                            <span style={{ color: 'brown', fontSize: '14px', marginLeft: '4px' }}>
                                {formatDateForInput(formData.PurchaseOrderDate)}
                            </span>
                        </label>
                    </div>

                    <div className="mr-4">
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billNumber" style={{ fontSize: '12px' }}>
                            PO No :
                            <span style={{ color: 'darkblue', fontSize: '14px', marginLeft: '4px' }}>
                                {formData.PurchaseOrderNo || ''}
                            </span>
                        </label>
                    </div>

                    <div className="mr-4">
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billDate" style={{ fontSize: '12px' }}>
                            Item Count :
                            <span style={{ color: '#F2613F', fontSize: '14px', marginLeft: '4px' }}>
                                {selectedItems.length}
                            </span>
                        </label>
                    </div>

                    <div>
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="totalQuantity" style={{ fontSize: '12px' }}>
                            Total QTY :
                            <span style={{ color: 'green', fontSize: '14px', marginLeft: '4px' }}>
                                {formData.TotalQuantity}
                            </span>
                        </label>
                    </div>
                </div>

                <div className="flex mt-8 w-full sm:w-auto">
                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                    </Button>

                    <Button
                        color="error"
                        component={Link}
                        to="/PurchaseOrderIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                <div className="w-full pr-4" style={{ marginTop: '1%' }}>
                    <div className="w-full mb-2 flex">
                        <Tooltip title={`Address : ${formData.SupplierAddress}`}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: 'white',
                                        color: 'darkblue',
                                        border: '1px solid white',
                                        fontWeight: 'bold',
                                        boxShadow: 2,
                                        height: '40px',
                                        fontSize: '12px'
                                    },
                                },
                            }}>
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                    Supplier Name   <span style={{ marginLeft: '20px', color: 'darkmagenta' }}>InvoiceType :  {formData.InvoiceTypeName} </span>

                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.SupplierName}
                                    type="text"
                                    placeholder="CustomerName"
                                    name='CustomerName'
                                    readOnly
                                />
                            </div>
                        </Tooltip>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                GST Number
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.GSTNumber}
                                type="text"
                                placeholder="GSTNumber"
                                name='GSTNumber'
                                readOnly
                            />

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Bill Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillNumber || ''}`}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                                onChange={handleChange}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Bill Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                type="date"
                                name='BillDate'
                                onChange={handleChange}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Clearing Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ClearingDate)}
                                type="date"
                                name='ClearingDate'
                                onChange={handleChange}
                            />
                        </div>


                    </div>


                    <div className="w-full mb-2 flex" style={{ backgroundColor: 'white', borderRadius: '10px' }}>

                        <div className="w-1/4 mr-2" style={{ marginTop: '5px', marginLeft: '5px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Amount : <span style={{ color: 'red', fontSize: '14px' }}>{formData.Amount}</span>
                            </label>

                        </div>

                        <div className="w-1/4 mr-2" style={{ marginTop: '5px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Discount : <span style={{ color: 'green', fontSize: '14px' }}>{formData.DiscountAmount}</span>
                            </label>

                        </div>

                        <div className="w-1/4 mr-2" style={{ marginTop: '5px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                CGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.CGSTAmount}</span>
                            </label>

                        </div>

                        <div className="w-1/4 mr-2" style={{ marginTop: '5px' }}>
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                                htmlFor="gstNumber"
                            >
                                SGST :
                                <span style={{ color: 'red', fontSize: '14px', marginLeft: '5px' }}>
                                    {formData.SGSTAmount}
                                </span>
                            </label>
                        </div>

                        <div className="w-1/4 mr-2" style={{ marginTop: '5px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                IGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.IGSTAmount}</span>
                            </label>

                        </div>

                        <div className="w-3/4 mr-2">
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                onChange={handleChange}
                            />
                        </div>


                    </div>

                    <div className="w-full mb-2 flex">
                        <div className="w-1/3 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Freight  <span style={{ marginLeft: '5px', color: 'darkmagenta' }}> {formData.FreightGSTRate}%</span> <span style={{ marginLeft: '10px', color: 'red', fontWeight: 'bold' }}> (₹) {formData.FreightGSTAmount}</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.FreightAmount}
                                type="text"
                                placeholder="FreightAmount"
                                style={{ textAlign: 'right', fontWeight: 'bold' }}
                                name='FreightAmount'
                                onChange={handleChange}
                                min="0"
                            />
                        </div>

                        <div className="w-1/3 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Packing  <span style={{ marginLeft: '5px', color: 'darkmagenta' }}> {formData.PackingGSTRate}%</span> <span style={{ marginLeft: '10px', color: 'red', fontWeight: 'bold' }}> (₹) {formData.PackingGSTAmount}</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.PackingAmount}
                                type="text"
                                placeholder="PackingAmount"
                                style={{ textAlign: 'right', fontWeight: 'bold' }}
                                name='PackingAmount'
                                onChange={handleChange}
                                min="0"
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                TCS
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.TCSAmount}
                                type="number"
                                placeholder="TCS Amount"
                                style={{ textAlign: 'right', fontWeight: 'bold' }}
                                name='TCSAmount'
                                onChange={handleChange}
                                min="0"
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Round Off
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.RoundOff}
                                type="text"
                                placeholder="RoundOff"
                                style={{ textAlign: 'right', fontWeight: 'bold' }}
                                name='RoundOff'
                                readOnly
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Total
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.TotalAmount}
                                type="text"
                                placeholder="TotalAmount"
                                style={{ textAlign: 'right', fontWeight: 'bold' }}
                                name='TotalAmount'
                                readOnly
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Paid
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.PaidAmount}
                                type="number"
                                placeholder="PaidAmount"
                                style={{ textAlign: 'right', fontWeight: 'bold' }}
                                name='PaidAmount'
                                onChange={handleChange}
                                max={formData.TotalAmount}
                                min="0"
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Balance
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:shadow-outline"
                                value={formData.BalanceAmount}
                                type="text"
                                placeholder="BalanceAmount"
                                style={{
                                    textAlign: 'right',
                                    fontWeight: 'bold',
                                    color: formData.BalanceAmount > 0 ? 'red' : 'inherit' // Sets color to red if BalanceAmount > 0
                                }}
                                name='BalanceAmount'
                                readOnly
                            />
                        </div>

                    </div>

                    <div className="w-full mb-2 flex">
                        <div className="w-full mr-3">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                Item Name
                            </label>

                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchItemOptions}
                                onInputChange={handleItemChange}
                                onChange={handleChangeDrop}
                                value={selectedItemOption}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '37px',         // Adjust height
                                        minHeight: '37px',      // Ensure it doesn't shrink below this
                                        fontSize: '15px',       // Adjust font size
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '15px',       // Adjust font size for input text
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '15px',       // Adjust font size for selected value
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Quantity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="Quantity"
                                placeholder="Quantity"
                                value={modalData.Quantity}
                                onChange={handleModalInputChange}
                                style={{ height: '35px' }}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="Rate"
                                placeholder="Rate"
                                value={modalData.Rate}
                                onChange={handleModalInputChange}
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveModalData}
                                style={{
                                    background: 'linear-gradient(to right, #16423C,green)',
                                    color: 'white',
                                    fontWeight: 'bolder',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                    maxHeight: '35px',
                                    //marginLeft: '5px',
                                    marginLeft: '6px',
                                    marginTop: '25px'
                                }}>
                                Add
                            </button>
                        </div>
                    </div>


                    {/* Purchase Order Table */}


                    <div className="w-full mb-2" style={{ marginTop: '15px', overflow: 'auto' }}>
                        <table
                            className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                            style={{ borderCollapse: 'collapse' }}
                        >
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px' }}></th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px' }}>ITEM NAME</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>ORD QTY</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>RECV QTY</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>RATE</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>AMOUNT</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>DIS %</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>DIS ₹</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>TOTAL</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>MFG. DATE</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#A10035', padding: '3px', textAlign: 'center' }}>EXP. DATE</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.map((item, index) => {
                                    const details = orderDetails[item.Id] || {};
                                    const defaultOrderQty = item.ApprovedQuantity || 0;
                                    const orderQty = orderQuantities[item.Id] || defaultOrderQty;

                                    return (
                                        <tr key={index} className="border-b"
                                            style={{
                                                backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                borderBottom: '1px solid #E0E0E0',
                                                transition: 'transform 0.2s ease-in-out',
                                                cursor: 'pointer',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                        >

                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '75px' }}>

                                                <Tooltip
                                                    title="Delete Purchase Order"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: 'darkolivegreen',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                fontSize: '0.875rem',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <DeleteIcon
                                                        style={{ color: 'brown', cursor: 'pointer', marginLeft: '20px', marginTop: '-5px' }}
                                                        onClick={() => openConfirmDialog(index)}
                                                    />
                                                </Tooltip>
                                            </td>
                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '250px' }}>{item.ItemName}</td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '10px', width: '50px' }}>
                                                <input
                                                    value={item.OrderQuantity}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    type="number"
                                                    value={item.Quantity}
                                                    onChange={(e) => handleCalculation(e, index, 'Quantity')}
                                                    className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#C9E9D2', textAlign: 'right' }}
                                                    min="0"
                                                    aria-label={`Order quantity for item ${item.Id}`}
                                                    name="Quantity"
                                                />
                                            </td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.Rate || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'Rate')}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    type="number"
                                                    name="Rate"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.Amount || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    name="Amount"
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountPercentage || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'DiscountPercentage')}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    type="number"
                                                    name="DiscountPercentage"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountAmount || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'DiscountAmount')}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.TotalAmount || 0}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#C7FFD8', textAlign: 'right' }}
                                                />
                                            </td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '15px' }}>
                                                <input
                                                    type="date"
                                                    value={formatDateForInput(item.ManufacturingDate)}
                                                    className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#C4DAD2' }}
                                                    name='ManufacturingDate'
                                                    onChange={(e) => handleCalculation(e, index, 'ManufacturingDate')}
                                                />
                                            </td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '15px' }}>
                                                <input
                                                    type="date"
                                                    value={formatDateForInput(item.ExpirydDate)}
                                                    className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#C4DAD2' }}
                                                    name='ExpirydDate'
                                                    readOnly
                                                />
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default PurchaseCreate;
